import { formatDate } from 'utils';

export const columns = [
  {
    title: '№',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Наименование',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: 'Создан',
    dataIndex: 'created',
    key: 'created',
    render: (value) => formatDate(value),
  },
];
